<template>
		<div id="pageRoot" class="backgroundDeaf" style="background-color: var(--book-background-color)">
			<div class="pageSVG">
				<img src="/pages/img/sordo2/svgPage8b.svg" class="pageElement" style=" width: 100%; height: auto;">
			</div>	
			<uploaded-image class="image-first-friend pageElement" v-bind:page="$parent.page" v-bind:type="$parent.type" number=2></uploaded-image>
			<uploaded-image class="image-second-friend pageElement" v-bind:page="$parent.page" v-bind:type="$parent.type" number=3></uploaded-image>
			<uploaded-image class="image-third-friend pageElement" v-bind:page="$parent.page" v-bind:type="$parent.type" number=4></uploaded-image>
		<!--BUTTONS--------------------------------------------------------------------------------------------------------->
			<div id="buttonUploadImage02" style="position: absolute; margin-left: 3%; margin-top: 12%; z-index: 10">
				<ImageUpload v-bind:page="$parent.page" v-bind:type="$parent.type" number=2 style=" transform: rotate(-3deg); z-index: 10"></ImageUpload>
			</div>
			<div id="buttonUploadImage03" style="position: absolute; margin-left: 61%; margin-top: 12.5%; z-index: 10">
				<ImageUpload v-bind:page="$parent.page" v-bind:type="$parent.type" number=3 style="transform: rotate(11deg);"></ImageUpload>
			</div>
			<div id="buttonUploadImage04" style="position: absolute; margin-left: 59%; margin-top: 72%; z-index: 10">
				<ImageUpload v-bind:page="$parent.page" v-bind:type="$parent.type" number=4 style="transform: rotate(3.6deg);"></ImageUpload>
			</div>
		<!--BUTTONS--------------------------------------------------------------------------------------------------------->

		<!-- TEXTOS -------------------------------------------------------------------------------------------------------->
			<saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=3 class="first-friend pageTextNormalDeaf black-text"/>
			<saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=4 class="second-friend pageTextNormalDeaf black-text"/>
			<saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=5 class="third-friend pageTextNormalDeaf black-text"/>
		<!-- TEXTOS -------------------------------------------------------------------------------------------------------->

		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
		</div>
</template>
<style scoped>
@import '../../../assets/css/sordoStyle.css';
.name{
	width:200px;
	position:static !important;
}
.age {
	width:40px;
	position:static !important;
}
.image-top{
	position:absolute;
    left: 350px;
    top: 395px;
    width: 583px;
    height: 374px;
}
.image-first-friend{
    position: absolute;
    left: 6%;
    top: 15%;
    width: 350px;
    height: 350px;
    transform: rotate(-3deg);
}
.image-second-friend{
    position: absolute;
    left:58%;
    top: 16.5%;
    width: 350px;
    height: 350px;
    transform: rotate(11deg);
}
.image-third-friend{
    position: absolute;
    left: 59%;
    top: 63%;
    width: 350px;
    height: 350px;
    transform: rotate(3.6deg);
}
.first-friend{
	position: absolute;
	width: 350px;	
    left: 7%;
    top: 42%;
    font-size: 45px;
    transform: rotate(-3deg);
}
.second-friend{
	position: absolute;
	width: 350px;	
    left: 54%;
    top: 43%;
    font-size: 45px;
    transform: rotate(11deg);
}
.third-friend{
	position: absolute;
	width: 350px;	
    left: 57%;
    top: 90%;
    font-size: 45px;
    transform: rotate(3.8deg);
}
</style>

<script>
	import ImageUpload from '../../../components/ImageUpload.vue'
	export default 
	{
		name: 'App',
		components:
		{
			ImageUpload
		}
	}
</script>